import { Application, ApplicationChannel } from '../types';

/**
 * A self-declared application (referral/direct) has no email thread — every
 * email-only affordance (reply, follow-up, retry contact) must be hidden for
 * it, and its crawled contact must not be shown as "who we reached".
 * `channel` is absent on older backends → classic beast_outreach behavior.
 */
export const isDeclaredApplication = (
  app: Pick<Application, 'channel'>
): app is Pick<Application, 'channel'> & { channel: 'referral' | 'direct' } =>
  app.channel === 'referral' || app.channel === 'direct';

export const channelTagLabel = (channel: ApplicationChannel): string =>
  channel === 'referral' ? 'Referral' : channel === 'direct' ? 'Direct' : 'Beast outreach';
